var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('el-result',{attrs:{"icon":"error","title":"404","subTitle":"页面不存在或路径错误或页面无权限"}},[_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){return _vm.$router.push('/layout/home')}}},[_vm._v("返回首页")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }